(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['module'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    }
})(this, function(module){
    var STRING = 'string';
    var PROD = "prod";
    var ENV_PROP = "env_";
    var moduleEnv = false;

    if (module && typeof module.config == "function") {
        (function(){
            var conf = module.config();
            if (typeof conf === STRING && conf) {
                moduleEnv = conf;
            }
        })();
    } 

    function createDatasourceEnv() {

        var currentEnv;
        var dscache = {};

        function datasourceEnv () {
            return datasourceEnv.env;
        };

        datasourceEnv.set = function (env) {
            // leverage setter below
            datasourceEnv.env = env;
            return currentEnv;
        }

        Object.defineProperty(datasourceEnv,'env',{
            enumerable : false,
            configurable : false,
            get : function () {
                return currentEnv;
            },
            set : function (env) {
                env = (env || currentEnv || PROD).toLowerCase();
                if (env !== currentEnv) {
                    currentEnv = env;
                    datasourceEnv.cache = dscache = {};
                    datasourceEnv.env_prop_lower = (datasourceEnv.env_prop = ENV_PROP + currentEnv).toLowerCase();
                }
            }
        });
        datasourceEnv.env = typeof moduleEnv === STRING ? moduleEnv : PROD;
        datasourceEnv.cache=dscache;

        return datasourceEnv;
    }

    var sharedEnv = createDatasourceEnv();

    sharedEnv.createDatasourceEnv = createDatasourceEnv;

    sharedEnv.env = moduleEnv;

	return sharedEnv;
});